import { TREES_WIDGET_DATA_ACTIONS } from '../../dataFetchers/treesDataFetcher';

const treesWidgetReducer = (state = {
    data: null,
    error: null
}, action) => {
    switch(action.type) {
        case TREES_WIDGET_DATA_ACTIONS.FETCH_TREES_WIDGET_DATA_SUCCESS: 
            if (action.payload.consumption && action.payload.noOfTrees) {
                state = {
                    ...state,
                    data: {
                        consumption: action.payload.consumption,
                        noOfTrees: action.payload.noOfTrees 
                    }
                };
            }
            else {
                state = {
                    ...state,
                    error: true
                }
            }
            break;
        case TREES_WIDGET_DATA_ACTIONS.FETCH_TREES_WIDGET_DATA_FAILED: 
            state = {
                ...state,
                error: action.payload
            };
            break;
        default:
            break;
    }
    return state;
};

export default treesWidgetReducer;